import { DateTime } from 'luxon'

import { Store } from 'pullstate'

const AccountStore = new Store(function initStore ()
{
	const store =
	{
		status: 'init' // 'set' si défini, 'expired' si expiré
	};

	const code_client = window.localStorage.getItem('account@code_client');
	const status = window.localStorage.getItem('account@status');
	const date = DateTime.fromISO(window.localStorage.getItem('account@date'));

	if (status !== 'set') return store;

	const expired = date.isValid
	? date.plus({ hours: 1 }) < DateTime.now()
	: true;

	if (expired)
	{
		window.localStorage.setItem('account@status', 'expired');
		store.status = 'expired';

		return store;
	}

	if (code_client) store.code_client = code_client;
	if (status) store.status = status;
	if (date.isValid) store.date = date.toISO();

	store._id = window.localStorage.getItem('account@_id') || '';

	return store;
}());

export default AccountStore;